"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanBookingFieldField = exports.PlanBookingFieldCategory = void 0;
/**
 * Enum/Mapping between plan booking fields and the TABLES they are associated with. So for example,
 * a field with PlanBookingFieldCategory = ACCOUNT means that the answer to this question is a reference to
 * the accounts table. The column is defined by PlanBookingFieldField.
 *
 * Note: this is more of an internal reference value because there's currently nothing dynamic in code, so even if
 * we have a completely random value here the code should still work because in the end the field and value we're
 * looking for is hardcoded in code and not used by this. It's just used to validate a booking to make sure it answered
 * all the necessary details.
 * The table name is more of a reference of what table would be mostly related to the info we're requesting from the user
 */
var PlanBookingFieldCategory;
(function (PlanBookingFieldCategory) {
    PlanBookingFieldCategory["ACCOUNT_VEHICLES_BOOKINGS"] = "account_vehicles_bookings";
    PlanBookingFieldCategory["ACCOUNT"] = "account";
    PlanBookingFieldCategory["BOOKING"] = "bookings";
    PlanBookingFieldCategory["CUSTOM"] = "custom";
    PlanBookingFieldCategory["PASSES"] = "passes";
})(PlanBookingFieldCategory || (exports.PlanBookingFieldCategory = PlanBookingFieldCategory = {}));
/**
 * Enum/Mapping between plan booking fields and the COLUMNS they are associated with. So for example,
 * a field with PlanBookingFieldField = PHONE_NUMBER means that the answer to this question is a reference to
 * the phone_number column. The table is defined by PlanBookingFieldCategory
 *
 * Note: this is more of an internal reference value because there's currently nothing dynamic in code, so even if
 * we have a completely random value here the code should still work because in the end the field and value we're
 * looking for is hardcoded in code and not used by this. It's just used to validate a booking to make sure it answered
 * all the necessary details.
 * The column name is more of a reference of what column would be mostly related to the info we're requesting from the user
 */
var PlanBookingFieldField;
(function (PlanBookingFieldField) {
    PlanBookingFieldField["PHONE_NUMBER"] = "phone_number";
    PlanBookingFieldField["HAS_EV_CHARGING"] = "has_ev_charging";
    PlanBookingFieldField["RESPONSES"] = "responses";
    PlanBookingFieldField["ACCOUNT_VEHICLE_ID"] = "account_vehicle_id";
    PlanBookingFieldField["BOOKING_ITEMS"] = "booking_items";
    PlanBookingFieldField["PASS_ACCESS_CARD"] = "pass_access_card";
    PlanBookingFieldField["START_DATE"] = "start_date";
    PlanBookingFieldField["INDIVIDUAL_BOOKING_ITEM_SELECTION"] = "individual_booking_item_selection";
    PlanBookingFieldField["BOOKING_ACCESSORIES"] = "booking_accessories";
    PlanBookingFieldField["DATE_RANGE"] = "date_range";
})(PlanBookingFieldField || (exports.PlanBookingFieldField = PlanBookingFieldField = {}));
//# sourceMappingURL=PlanBookingField.js.map